import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What is leisure?",
  "description": "",
  "published": "2012-07-03T00:00:00.000Z",
  "redirect_from": ["/blog/?p=4769"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The other day somebody asked me `}<em parentName="p">{`"Ok so how do you define leisure?"`}</em>{` ... how `}<strong parentName="p">{`do`}</strong>{` you define leisure?`}</p>
    <p>{`Intuitively everyone understands what leisure is - it's that time you spend not working. But then what is work? Are you working only when you're making money (a popular definition with parent figures)? Or is doing the dishes and cleaning up your home and so on work as well ... because it certainly doesn't `}<em parentName="p">{`feel`}</em>{` like leisure.`}</p>
    <p>{`Ok, so maybe leisure is that time when you aren't productive in some way.`}</p>
    <p>{`But when are you productive?`}</p>
    <p>{`Are you productive only when you're pumping out results? What about when you're doing sports? Sports are relaxing, so they look a lot like leisure. But at the same time, a lot of people get paid good money to do sports under the pretense of physical labour. Plus sports is a godo way to keep your energy levels up and make you generally more productive.`}</p>
    <p>{`Let's not forget sports keep you healthy and healthy people output more "work".`}</p>
    <p>{`So let's take sports out of the `}<em parentName="p">{`leisure`}</em>{` bag for now - they're too generally useful.`}</p>
    <p>{`What about something far more innocent - a nice walk in the park? That's leisure! That is most definitely leisure, right!? Then again ... Stephen King is known for taking a walk every day at the same time, with the specific purpose of being alone to think. So he can write better stories.`}</p>
    <p>{`Story writing, for him, is work. So is that walk a leisure activity, or a work activity?`}</p>
    <p>{`And let's not forget most of us get really good ideas when doing nothing in particular. When we're just taking a shower or something ... so should we start identifying all bits of the day as work?`}</p>
    <p>{`bah ne, ne to je glup post ... I don't have anything to say here`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      